var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-bottom-spaced bold"},[_vm._v("Overall Survival:")]),_c('div',{attrs:{"id":"chart"}})])
}]

export { render, staticRenderFns }